"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _dataAdmin = require("@/api/dataAdmin");
var _creatApp = require("@/api/creatApp");
var _download = require("@/utils/download");
var _AcquisitionTime = require("@/utils/AcquisitionTime");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 通用文件导出模块 id，见后端 FileModule.STATS_GMV
var EXPORT_MODULE_ID = 6;
var _default = exports.default = {
  name: 'GmvStatistics',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      size: 10,
      summary: {},
      dateRange: [],
      queryParams: {
        timeRange: 1,
        startTime: '',
        endTime: '',
        unionCode: '',
        appId: ''
      },
      timeRangeOptions: [{
        label: '全部',
        value: 1
      }, {
        label: '最近7天',
        value: 2
      }, {
        label: '最近30天',
        value: 3
      }, {
        label: '本月',
        value: 4
      }, {
        label: '上月',
        value: 5
      }, {
        label: '自定义时间范围',
        value: 6
      }],
      // 与订单列表页的渠道 tab 一一对应
      unionOptions: [{
        label: '淘宝',
        value: 'TB'
      }, {
        label: '京东',
        value: 'JD'
      }, {
        label: '拼多多',
        value: 'PDD'
      }, {
        label: '唯品会',
        value: 'WPH'
      }, {
        label: '抖音',
        value: 'DY'
      }, {
        label: '快手',
        value: 'KS'
      }, {
        label: '美团',
        value: 'MT'
      }, {
        label: '饿了么',
        value: 'ELM'
      }, {
        label: '滴滴出行',
        value: 'DD'
      }, {
        label: '直充卡券',
        value: 'QF'
      }, {
        label: '在线点单',
        value: 'OT'
      }, {
        label: '苏宁',
        value: 'SN'
      }, {
        label: '多麦聚合',
        value: 'DM'
      }, {
        label: '腾讯云选',
        value: 'TXYX'
      }, {
        label: '1688',
        value: 'ALI'
      }, {
        label: '淘宝直播',
        value: 'ZB'
      }, {
        label: '闲鱼',
        value: 'XY'
      }],
      appOptions: [],
      exportDialogVisible: false,
      activeExportTab: 'export',
      exportForm: {
        fileName: '',
        fileType: 0
      },
      exportRules: {
        fileName: [{
          required: true,
          message: '请输入文件名',
          trigger: 'blur'
        }],
        fileType: [{
          required: true,
          message: '请选择导出格式',
          trigger: 'change'
        }]
      },
      recordQueryParams: {
        page: 1,
        size: 10,
        recordType: 0,
        moduleId: EXPORT_MODULE_ID,
        fileName: '',
        status: undefined
      },
      recordTotal: 0,
      recordTableData: [],
      recordLoading: false
    };
  },
  computed: {
    isSysAdmin: function isSysAdmin() {
      // 超管端 appId 固定为 0，租户端为具体 appId；登录流程未写入 roles，不能用 roles 判断
      return this.$store.getters.appId !== '' && Number(this.$store.getters.appId) === 0;
    },
    // u_file_record 按 appId 隔离：超管端平台级任务固定 0，租户端取自身 appId
    fileAppId: function fileAppId() {
      return this.isSysAdmin ? 0 : this.$store.getters.appId;
    },
    statCards: function statCards() {
      var s = this.summary || {};
      return [{
        label: '新增会员数',
        value: this.fmt(s.memberCount)
      }, {
        label: '总订单数（笔）',
        value: this.fmt(s.orderCount)
      }, {
        label: '有效订单数（笔）',
        value: this.fmt(s.validOrderCount)
      }, {
        label: '总订单金额（元）',
        value: this.fmt(s.orderAmount, true)
      }, {
        label: '有效订单金额（元）',
        value: this.fmt(s.validOrderAmount, true)
      }, {
        label: '总订单佣金（元）',
        value: this.fmt(s.income, true)
      }, {
        label: '有效订单佣金（元）',
        value: this.fmt(s.validIncome, true)
      }];
    }
  },
  mounted: function mounted() {
    if (this.isSysAdmin) {
      this.fetchAppOptions();
    }
    this.fetchData();
  },
  methods: {
    // 0 或空统一展示为 -
    fmt: function fmt(val, isAmount) {
      if (val === null || val === undefined || val === '' || val === 0) {
        return '-';
      }
      return isAmount ? "\xA5".concat(val) : val;
    },
    fetchAppOptions: function () {
      var _fetchAppOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _creatApp.getList)({});
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.appOptions = res.data || [];
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function fetchAppOptions() {
        return _fetchAppOptions.apply(this, arguments);
      }
      return fetchAppOptions;
    }(),
    // 租户端后端强制要求传自己的 appId；超管端可选，空为全部租户
    buildFilterParams: function buildFilterParams() {
      var params = {
        startTime: this.queryParams.startTime,
        endTime: this.queryParams.endTime
      };
      if (this.queryParams.unionCode) {
        params.unionCode = this.queryParams.unionCode;
      }
      if (this.isSysAdmin) {
        if (this.queryParams.appId) {
          params.appId = this.queryParams.appId;
        }
      } else {
        params.appId = this.$store.getters.appId;
      }
      return params;
    },
    fetchData: function fetchData() {
      this.fetchSummary();
      this.fetchPage();
    },
    fetchSummary: function fetchSummary() {
      var _this = this;
      (0, _dataAdmin.statisticsGmvApi)(this.buildFilterParams()).then(function (res) {
        _this.summary = res.code === 0 ? res.data || {} : {};
      }).catch(function () {
        _this.summary = {};
      });
    },
    fetchPage: function fetchPage() {
      var _this2 = this;
      this.loading = true;
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.buildFilterParams()), {}, {
        page: this.page,
        size: this.size
      });
      (0, _dataAdmin.statsGmvPageApi)(params).then(function (res) {
        if (res.code === 0 && res.data) {
          _this2.tableData = res.data.data || [];
          _this2.total = res.data.total || 0;
        } else {
          _this2.tableData = [];
          _this2.total = 0;
        }
      }).catch(function () {
        _this2.tableData = [];
        _this2.total = 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    onTimeRangeChange: function onTimeRangeChange(val) {
      this.queryParams.timeRange = val;
      if (val === 6) {
        this.dateRange = [];
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
        return;
      }
      var range = [];
      switch (val) {
        case 2:
          range = (0, _AcquisitionTime.getLast7Days)();
          break;
        case 3:
          range = (0, _AcquisitionTime.getLast30Days)();
          break;
        case 4:
          range = (0, _AcquisitionTime.getLastCurrentMonth)();
          break;
        case 5:
          range = (0, _AcquisitionTime.getLastMonthDates)();
          break;
      }
      if (range.length === 2) {
        this.dateRange = range;
        this.queryParams.startTime = range[0];
        this.queryParams.endTime = range[1];
      } else {
        // 全部：时间传空
        this.dateRange = [];
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
      this.page = 1;
      this.fetchData();
    },
    onDateRangeChange: function onDateRangeChange(val) {
      if (val && val.length === 2) {
        this.queryParams.startTime = val[0];
        this.queryParams.endTime = val[1];
      } else {
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
    },
    onQuery: function onQuery() {
      if (this.queryParams.timeRange === 6) {
        if (!this.dateRange || this.dateRange.length !== 2) {
          this.$message.warning('请选择自定义时间范围');
          return;
        }
      }
      this.page = 1;
      this.fetchData();
    },
    onReset: function onReset() {
      this.queryParams = {
        timeRange: 1,
        startTime: '',
        endTime: '',
        unionCode: '',
        appId: ''
      };
      this.dateRange = [];
      this.page = 1;
      this.fetchData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.fetchPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.fetchPage();
    },
    openExportDialog: function openExportDialog() {
      this.exportDialogVisible = true;
      this.activeExportTab = 'export';
      this.exportForm.fileName = '';
      this.exportForm.fileType = 0;
      this.fetchExportRecord();
    },
    onExportDialogClose: function onExportDialogClose() {
      this.$refs.exportForm && this.$refs.exportForm.resetFields();
    },
    onConfirmExport: function onConfirmExport() {
      var _this3 = this;
      this.$refs.exportForm.validate(function (valid) {
        if (!valid) return;
        _this3.$confirm('确认导出该数据？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var params = {
            appId: _this3.fileAppId,
            moduleId: EXPORT_MODULE_ID,
            fileName: _this3.exportForm.fileName,
            fileType: _this3.exportForm.fileType,
            querySnapshot: {
              appId: _this3.isSysAdmin ? _this3.queryParams.appId || null : _this3.$store.getters.appId,
              startTime: _this3.queryParams.startTime,
              endTime: _this3.queryParams.endTime,
              unionCode: _this3.queryParams.unionCode || null
            }
          };
          (0, _dataAdmin.submitFileExport)(params).then(function () {
            _this3.$message.success('导出任务已创建');
            _this3.exportDialogVisible = false;
          }).catch(function () {
            _this3.$message.error('导出失败');
          });
        }).catch(function () {});
      });
    },
    onResetExport: function onResetExport() {
      this.$refs.exportForm.resetFields();
    },
    onExportTabClick: function onExportTabClick(tab) {
      if (tab.name === 'record' && this.recordTableData.length === 0) {
        this.fetchExportRecord();
      }
    },
    fetchExportRecord: function fetchExportRecord() {
      var _this4 = this;
      this.recordLoading = true;
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.recordQueryParams), {}, {
        appId: this.fileAppId
      });
      if (params.status === undefined || params.status === null || params.status === '') {
        delete params.status;
      }
      if (!params.fileName) {
        delete params.fileName;
      }
      (0, _dataAdmin.queryExportRecord)(params).then(function (res) {
        if (res.code === 0 && res.data) {
          _this4.recordTableData = res.data.data || [];
          _this4.recordTotal = res.data.total || 0;
        }
      }).catch(function () {}).finally(function () {
        _this4.recordLoading = false;
      });
    },
    onQueryRecord: function onQueryRecord() {
      this.recordQueryParams.page = 1;
      this.fetchExportRecord();
    },
    onResetRecord: function onResetRecord() {
      this.recordQueryParams = {
        page: 1,
        size: 10,
        recordType: 0,
        moduleId: EXPORT_MODULE_ID,
        fileName: '',
        status: undefined
      };
      this.fetchExportRecord();
    },
    handleRecordSizeChange: function handleRecordSizeChange(val) {
      this.recordQueryParams.size = val;
      this.fetchExportRecord();
    },
    handleRecordCurrentChange: function handleRecordCurrentChange(val) {
      this.recordQueryParams.page = val;
      this.fetchExportRecord();
    },
    onDownloadRecord: function onDownloadRecord(row) {
      var _this5 = this;
      this.$confirm('确认下载该文件？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params = {
          appId: _this5.fileAppId,
          recordType: 0,
          moduleId: EXPORT_MODULE_ID,
          taskId: row.taskId
        };
        (0, _dataAdmin.downloadExportFile)(params).then(function (res) {
          if (res.data) {
            var url = res.data;
            if (url.startsWith('http')) {
              var link = document.createElement('a');
              link.href = url;
              link.download = row.fileName || '';
              link.style.display = 'none';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {
              (0, _download.selfDownload)(url);
            }
          } else {
            _this5.$message.warning('下载链接为空');
          }
        }).catch(function () {
          _this5.$message.error('下载失败');
        });
      }).catch(function () {});
    }
  }
};